const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function getAssessmentEmailError(value, preferredContactMethod) {
  const email = typeof value === "string" ? value.trim() : "";
  const method = typeof preferredContactMethod === "string" ? preferredContactMethod.trim() : "";

  if (!email && method === "email") return "Enter your email address so we can email you.";
  if ((value != null && typeof value !== "string") || (email && (email.length > 254 || !EMAIL_PATTERN.test(email)))) {
    return "Enter a valid email address.";
  }
  return null;
}

export function getHomeAssessmentSuccessMessage(preferredContactMethod) {
  const followUp = preferredContactMethod === "email"
    ? "We’ll email you"
    : preferredContactMethod === "text"
    ? "We’ll text you"
    : "We’ll call you";
  return `${followUp} to confirm your water concerns and, when appropriate, arrange a visit. If you have them, keep your water test results, address details, and current equipment information handy. This request is not a booked appointment or final quote.`;
}
